import React, { useEffect } from "react";
import { Fragment, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import Alert from "react-s-alert";
import SVG from "react-inlinesvg";

import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";
import { Image, Modal, Button } from "react-bootstrap";
import moment from "moment";
import { DeletePopup } from "../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import EditWaitTime from "../../../reusableComponents/allPopupReusable/tableNumberPopup/EditWaitTime";
import { PopupIconButtonReusable } from "../../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
import { EventCountDownTimer } from "../../../reusableComponents/allPopupReusable/tableNumberPopup/EventCountDownTimer";
import { NewCountDown } from "../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import OrderDescModelBody from "../../../superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminOrdersTable/OrderDescModelBody";
import OrderEditModelBody from "../../../superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminOrdersTable/OrderEditModelBody";
import OrderLocation from "../../../superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminOrdersTable/OrderLocation";
import SubstituteModal from "../../../superAdminComponents/superAdminAllComponent/SuperAdminOrders/SuperAdminOrdersTable/SubstituteModal";

import {
  CLEAR_CART_DATA,
  CREATE_ORDER_VENDOR,
  SELECTED_SUBSTITUTE_ITEM,
  SET_VENDOR_ORDERING_CART_DATA,
  SUBSTITUTE_EXISTING_RECORDS,
} from "../../../../store/types";

import PropTypes from "prop-types";
import {
  cancel_item_order,
  debit_memo_order_cancel_item,
  edit_location,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import {
  get_menu_items_by_passing_item_id_in_array,
  update_item_menu_setup_without_loader,
} from "../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import {
  UpdateAvailabilityOfItem,
  SelectItemsToSubs,
} from "../../../superAdminComponents/superAdminAllComponent/superAdminVendorOrdersPrivate/VendorOrderTables";
import CallingButtonPopup from "../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import CallingCardDraggable from "../../../reusableComponents/allPopupReusable/CallingCardDraggable";
import SendSmsNew from "../../../reusableComponents/allPopupReusable/SendSmsNew";
import NotificationsNew from "../../../reusableComponents/allPopupReusable/NotificationsNew";
import ChatWindow from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
import LocationReusable from "../../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import EditOrder from "../OrderDashboard/EditOrder";
import GeoLocation from "../../../vendorOnboradingComponents/allScreens/MapSetup/GeoLoaction";
import isEmpty from "../../../../store/validation/is-Empty";
import ViewMobileOrder from "./ViewMobileOrder";
import { PopupInsideButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { CAR_COLORS, ORDER_TYPE_NAME } from "../../../../enums/OrderEnums";
import { getPendingPayment } from "../../../../function/getPendingPayment";
import { NOTAVAILABLEIMAGE } from "../../../../enums/GlobalEnums";
import { ITEMTYPEVEG, NEW_PAYMENT_TYPE } from "../../../../enums/OrderEnums";
import { TextField } from "@material-ui/core";
import { amApi } from "../../../../api/apiHelper";
import {
  calcFinalTotalEdit,
  calcTotalOriginalEdit,
  getAmountDetails,
} from "../../../../function/ordering";
import DeliveryPerson from "../../../reusableComponents/allPopupReusable/DeliveryPerson";
import AssignDeliveryPerson from "../../../reusableComponents/allPopupReusable/AssignDeliveryPerson";

function VendorOrderTablesBodyMobile(props) {
  const [show, setShow] = useState(false);
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const dispatch = useDispatch();

  // After scan complete to view
  const [openViewWhenScan, setopenViewWhenScan] = useState(false);
  useEffect(() => {
    if (
      props?.scanData?.scanData?.order_id ===
      props?.orderDetails?.order_id.toString()
    ) {
      setopenViewWhenScan(true);
    }
  }, [props?.scanData?.scanData, props?.orderDetails?.order_id.toString()]);

  const [locationTrack, setLocationTrack] = useState(false);
  const [orderID, setOrderID] = useState(null);

  //Model order view
  const [MrDetail, setMrDetail] = useState({ MrDetail: false });
  const viewOrderInDetail = () => setMrDetail({ MrDetail: !MrDetail.MrDetail });

  const [vtype, viewType] = useState(3);

  const [cookLevels, setCookLevels] = useState({
    spice: 4,
    sugar: 4,
    salt: 5,
    fat: 5,
    meat: 5,
    egg: 5,
  });

  const createdAt = new Date(props.orderDetails?.createdAt);

  const updatedTime = moment(
    props.orderDetails && props.orderDetails?.order_status === 0
      ? props?.orderDetails && props?.orderDetails?.createdAt
      : props?.orderDetails?.max_time_date ||
          props?.orderDetails?.OrderAcceptTime
  ).add(
    props.orderDetails && props.orderDetails?.order_status === 0
      ? parseInt(props.orderDetails?.wait_time)
      : parseInt(props.orderDetails?.max_time),
    "minutes"
  );
  // props.orderDetails?.max_time
  // const currentTimeTwo = new Date().getTime();
  // const updatedTimeNew = updatedTime.getTime();
  // const waitTime = parseInt(props.orderDetails?.max_time) * 60 * 1000;
  // let updateWaitTime = updatedTimeNew + waitTime;
  // let diff = updateWaitTime - currentTimeTwo;
  let diff = updatedTime.diff(moment());

  const acceptTime =
    props?.orderDetails?.order_status === 0
      ? new Date(props?.orderDetails?.createdAt)
      : props?.orderDetails?.order_status === 8
      ? new Date(props?.orderDetails?.createdAt)
      : props?.orderDetails?.order_status === 7
      ? new Date(props?.orderDetails?.createdAt)
      : new Date(props?.orderDetails?.createdAt);
  // : new Date(props?.orderDetails?.OrderAcceptTime);

  const orderEndTime =
    props?.orderDetails?.order_status === 0
      ? new Date()
      : props?.orderDetails?.order_status === 8
      ? new Date(props?.orderDetails?.updatedAt)
      : props?.orderDetails?.order_status === 7
      ? new Date(props?.orderDetails?.OrderCompleteTime)
      : new Date();

  var endSeatedTime = moment(orderEndTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(acceptTime).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);
  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  const seated_time_difference = (minutesSeated) => {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " hh : " + nMinutesSeated + " mins";
  };

  // const seatedTime = new Date(
  //   props.orderDetails && props.orderDetails?.OrderAcceptTime
  // );
  // var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  // var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  // let dateOneSeated = new Date(startTimeNew);
  // let dateTwoSeated = new Date(endSeatedTime);

  // let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  // let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);

  // function seated_time_difference() {
  //   let StartedTime = new Date(props.orderDetails?.OrderAcceptTime).getTime();
  //   let EndedTime = new Date(props.orderDetails?.OrderCompleteTime).getTime();
  //   let difference = EndedTime - StartedTime;
  //   let hourss = Math.floor(difference / 3.6e6);
  //   let minutess = Math.floor((difference % 3.6e6) / 6e4);
  //   return hourss + " hh : " + minutess + " mins";
  // }

  const calcTaxes = (data) => {
    let tax = Object.values(data).reduce(
      (a, b) => parseFloat(a || 0) + parseFloat(b || 0),
      0
    );

    return tax?.toFixed(2);
  };

  const prepData = () => {
    const formData = {};
    if (
      props.orderDetails &&
      props.orderDetails?.user_location &&
      props.orderDetails?.user_location.lat
    ) {
      formData.track_location = {};
      formData.track_location.latitude = props.orderDetails?.user_location.lat;
      formData.track_location.longitude =
        props.orderDetails?.user_location.long;
    }
    formData.user_details = props.orderDetails?.user_details;
    formData.user_details.name =
      props.orderDetails?.user_details.first_name +
      " " +
      props.orderDetails?.user_details.last_name;
    formData.diner_id = props.orderDetails?.order_id;

    formData.type = "ordering";

    return formData;
  };

  const prepareLevels = (data) => {
    let levelNames = [];

    if (data.spice_level) {
      let spice = "Spice : " + data.spice_level.level + "/" + cookLevels.spice;
      levelNames.push(spice);
    }

    if (data.salt_level) {
      let salt = "Salt : " + data.salt_level.level + "/" + cookLevels.salt;
      levelNames.push(salt);
    }

    if (data.sugar_level) {
      let sugar = "Sugar : " + data.sugar_level.level + "/" + cookLevels.sugar;
      levelNames.push(sugar);
    }

    if (data.fat_level) {
      let fat =
        "fat/oil/fried : " + data.fat_level.level + "/" + cookLevels.fat;
      levelNames.push(fat);
    }

    if (data.meat_cook_level) {
      let meat = "Meat : " + data.meat_cook_level.level + "/" + cookLevels.meat;
      levelNames.push(meat);
    }

    if (data.egg_cook_level) {
      let egg = "Egg : " + data.egg_cook_level.level + "/" + cookLevels.egg;
      levelNames.push(egg);
    }
    return levelNames.toString();
  };

  // const getAddOns = (data) => {
  //   let addOnsNames = [];
  //   if (data && data[0] && data[0].options) {
  //     for (let i = 0; i < data.length; i++) {
  //       for (let j = 0; j < data[i].options.length; j++) {
  //         addOnsNames.push(data[i].options[j].name);
  //       }
  //     }
  //   } else {
  //     for (let i = 0; i < data.length; i++) {
  //       addOnsNames.push(data[i].name);
  //     }
  //   }
  //   return addOnsNames.toString();
  // };

  const getAddOns = (data) => {
    let addOnsNames = [];
    if (data && data[0] && data[0].options) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].options.length; j++) {
          let addData = {};
          addData = data[i].options[j];
          // let addData = { multiple: [] };
          // if (data[i]?.options[j]?.checked) {
          //   addData._id = data[i].options[j]?._id;
          //   addData.name = data[i].options[j]?.name;
          //   addData.checked =
          //     data[i].options[j]?.checked !== undefined &&
          //     data[i].options[j]?.checked !== null
          //       ? data[i].options[j]?.checked
          //       : false;
          // } else {
          //   let addDataArr = [];
          //   let addObj = {};
          //   if (
          //     (data[i].options[j].multipleSize !== undefined &&
          //       data[i].options[j].multipleSize !== null) ||
          //     !data[i].options[j]?.checked
          //   ) {
          //     for (
          //       let k = 0;
          //       k < data[i]?.options[j]?.multipleSize.length;
          //       k++
          //     ) {
          //       if (data[i]?.options[j]?.multipleSize[k].checked) {
          //         addObj.multipleName =
          //           data[i]?.options[j]?.multipleSize[k].sizeDescription;
          //         addObj.itemPrice =
          //           data[i]?.options[j]?.multipleSize[k].itemPrice;
          //         addObj.checked = data[i]?.options[j]?.multipleSize[k].checked;
          //       }
          //     }
          //   }
          //   addData._id = data[i].options[j]?._id;
          //   addData.name = data[i].options[j]?.name;
          //   addData.checked =
          //     data[i].options[j]?.checked === undefined &&
          //     data[i].options[j]?.checked === null
          //       ? false
          //       : data[i].options[j]?.checked;
          //   // addData.multiple.push(addObj);
          // }

          // console.log("addData ===>", addData);
          // for (let k = 0; k < data[i]?.options[j]?.multipleSize.length; k++) {
          //   if (data[i]?.options[j]?.multipleSize[k]?.isSelect === true) {
          //     addData.multiple =
          //       data[i]?.options[j]?.multipleSize[k]?.sizeDescription;
          //   }
          // }
          addOnsNames.push(addData);
        }
      }
    }
    let newArray = [];
    if (addOnsNames.length > 0) {
      let uniqueObject = {};
      for (let i in addOnsNames) {
        let objTitle = addOnsNames[i]["_id"];
        uniqueObject[objTitle] = addOnsNames[i];
      }
      for (let i in uniqueObject) {
        newArray.push(uniqueObject[i]);
      }
    }
    // console.log("newArray", newArray);
    // else {
    //   for (let i = 0; i < data.length; i++) {
    //     addOnsNames.push(data[i].name);
    //   }
    //   return addOnsNames.toString();
    // }
    return newArray;
  };

  const [showCancel, setShowCancel] = useState(false);
  const [orderId, setOrderId] = useState();
  const [itemIndex, setItemIndex] = useState();
  const handleCloseCancel = () => {
    setShowCancel(false);
  };

  const onClickCancelOrder = (idOrder) => {
    setOrderId(idOrder);
    setShowCancel(true);
  };

  const handleClickNo = () => {
    setShowCancel(false);
  };

  const onEnableTrack = async (order) => {
    setLocationTrack(true);
    setOrderID(order);
  };

  const locationGranted = (position) => {};

  const onTracking = async () => {
    let permission = await window.navigator.permissions.query({
      name: "geolocation",
    });
    if (
      permission.state === "granted" &&
      (props?.orderDetails?.order_status === 4 ||
        props?.orderDetails?.order_status === 5)
    ) {
      let location = await GeoLocation(window.navigator);
      if (!isEmpty(location)) {
        const formData = {
          delivery_location: location,
          id: props?.orderDetails?._id,
        };
        props.edit_location(formData);
      }
      setTimeout(function () {
        onTracking();
      }, 15000);
    } else {
      navigator.geolocation.getCurrentPosition(locationGranted);
    }
  };

  useEffect(() => {
    if (locationTrack && orderID?._id) {
      onTracking();
    }
  }, [locationTrack]);

  const handleClickYes = () => {
    const formData = { order_status: 8, id: orderId };
    props.onUpdateOrderStatus(formData);
    setShowCancel(false);
  };

  const onClickChangeStatus = (orderStatus, id, orderType) => {
    var formData = {};
    if (orderType === 3 && orderStatus === 4) {
      // check for dine in order
      formData = { order_status: orderStatus + 2, id: id };
    } else {
      formData = { order_status: orderStatus + 1, id: id };
    }
    if (orderStatus + 1 === 1) {
      formData.OrderAcceptTime = new Date().getTime();
    }
    if (orderType === 3 && orderStatus === 6) {
      if (orderStatus + 1 === 7) {
        formData.OrderCompleteTime = new Date().getTime();
      }
    } else {
      if (orderStatus + 1 === 7) {
        formData.OrderCompleteTime = new Date().getTime();
      }
    }

    props.onUpdateOrderStatus(formData);
  };

  const onClickResetReject = (orderStatus, id, orderType) => {
    let prepData = {};
    if (orderStatus === 0) {
      prepData = { order_status: 8, id: id };
    } else if (orderStatus === 6 && orderType === 3) {
      prepData = { order_status: orderStatus - 2, id: id };
    } else {
      prepData = { order_status: orderStatus - 1, id: id };
    }
    props.onUpdateOrderStatus(prepData);
  };

  const [showHoldOrder, setShowHoldOrder] = useState(false);

  const handleCloseHoldOrder = () => {
    setShowHoldOrder(false);
  };

  const onClickHoldOrder = () => {
    const formData = { onhold: true, id: props.orderDetails?._id };
    props.onUpdateOrderStatus(formData);
  };

  const onChangeHold = (holdStatus, id) => {
    if (holdStatus) {
      const formData = { onhold: !holdStatus, id: id };
      props.onUpdateOrderStatus(formData);
    } else {
      setShowHoldOrder(true);
    }
  };

  const [showSubstitute, setShowSubstitute] = useState(false);
  const handleCloseSubstitute = () => {
    setShowSubstitute(false);
  };

  const onClickShowSubstituteModal = (itemData, id, index) => {
    setShowSubstitute(true);
    setSubstituteItemData(itemData);
    setOrderId(id);
    setItemIndex(index);
  };

  const calcDate = () => {
    return props.orderDetails?.later_date || props.orderDetails?.createdAt;
  };

  const calcItemsLength = () => {
    let count = 0;
    for (let i = 0; i < props.orderDetails?.order_items.length; i++) {
      if (
        props.orderDetails?.order_items[i].isSubstituted ||
        props.orderDetails?.order_items[i].isCancelled
      ) {
      } else {
        count += 1;
      }
    }
    return count;
  };

  const showSubstituteedItemText = () => {
    let data = "";
    for (let i = 0; i < props.orderDetails?.order_items.length; i++) {
      if (props.orderDetails?.order_items[i].isSubstituted) {
        data = "Substituted Item";
      }
    }
    return data;
  };

  const onSuccess = (memoId) => {
    try {
      const existingData = { ...props.orderDetails };
      const itemToCheck = existingData.order_items[itemIndex];
      itemToCheck.isCancelled = true;
      let newOrderData = existingData.order_items.filter(
        (ele, i) => !((ele.isSubstituted || ele.isCancelled) && itemIndex !== i)
      );
      const formData = {};
      formData.order_items = existingData.order_items;
      let orderData = calcFinalTotalEdit(
        formData.order_items,
        props.orderDetails,
        props.subscription
      );
      formData.total_amount = orderData.total;
      formData.base_amount = calcTotalOriginalEdit(formData.order_items);
      let taxesArr = [];
      formData.gstAmount = orderData.taxes.gst;
      formData.surCharges = orderData.taxes.surCharges;
      formData.order_id = existingData._id;
      const token = props?.auth?.user.accessToken;
      let cancelledCount = 0;
      for (let i = 0; i < formData.order_items.length; i++) {
        if (
          formData.order_items[i].isCancelled ||
          formData.order_items[i].isSubstituted
        ) {
          cancelledCount += 1;
        }
      }
      if (cancelledCount === formData.order_items.length) {
        formData.order_status = 8;
        formData.total_amount = 0;
        formData.base_amount = 0;
        formData.gstAmount = {};
      }
      props.cancel_item_order(token, formData, onSuccessfinal);
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  const onSuccessfinal = () => {};

  // const onClickPayLater = (data) => {
  //   let existingData = JSON.parse(JSON.stringify(data));
  //   dispatch({ type: CREATE_ORDER_VENDOR, payload: existingData });
  //   history.push("/reorderpayment", { type: "PAY_NOW" });
  // };

  const onClickPayLater = (data) => {
    let existingData = JSON.parse(JSON.stringify(data));
    dispatch({ type: CLEAR_CART_DATA, payload: [] });
    dispatch({ type: SET_VENDOR_ORDERING_CART_DATA, payload: existingData });
    dispatch({ type: CREATE_ORDER_VENDOR, payload: existingData });
    history.push("/reorderpayment", {
      type: "PAY_NOW",
      actionBy: data?.payment_method === 6 ? "PAYLATER" : "",
    });
  };
  const handleClickConfirm = () => {
    if (subType === "Substitute") {
      viewType(5);
      viewOrderInDetail();
      handleCloseSubstitute();
      let orderSelected = "";
      if (props.orderDetails?.order_type === 0) {
        orderSelected = "take_away";
      } else if (props.orderDetails?.order_type === 1) {
        orderSelected = "curb_side";
      } else if (props.orderDetails?.order_type === 2) {
        orderSelected = "skip_line";
      } else if (props.orderDetails?.order_type === 3) {
        orderSelected = "dine_in";
      } else if (props.orderDetails?.order_type === 7) {
        orderSelected = "home_delivery";
      }

      let existingData = JSON.parse(JSON.stringify(props.orderDetails));
      existingData.orderSelected = orderSelected;
      existingData.selectedTabId = 1;

      // dispatch({
      //   type: SELECTED_SUBSTITUTE_ITEM,
      //   payload: substituteItemData,
      // });
      dispatch({ type: CREATE_ORDER_VENDOR, payload: existingData });
    } else {
      // console.log(orderId);
      // console.log(substituteItemData);

      if (props.orderDetails?.payment_method !== 0) {
        const getAmount = getAmountDetails(props.orderDetails);
        let index = getAmount.ids.findIndex(
          (ele) => ele == substituteItemData._id
        );
        let formData = {};
        formData.amount =
          getAmount.discountPrices[index] + getAmount.charges[index];
        formData.order_id = orderId;
        formData.items = [];
        formData.items.push(substituteItemData);
        formData.items[0].isCancelled = true;
        const token = props.auth.user.accessToken;
        props.debit_memo_order_cancel_item(token, formData, onSuccess);
      } else {
        onSuccess();
      }
    }
  };
  const history = useHistory();
  const [subType, setSubType] = useState("Substitute");
  const [substituteItemData, setSubstituteItemData] = useState({});
  const [itemsId, setItemsId] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [selectedItemArray, setSelectedArray] = useState([]);
  const [itemsData, setItemsData] = useState([]);
  const [activeItemData, setActiveItemData] = useState();

  // const onClickEditOrder = (data) => {
  //   history.push({
  //     pathname: `/orderdashboard/editorder-request/${data._id}`,
  //     state: { orderDetails: data },
  //   });
  // };

  const onClickNext = () => {
    if (itemCount === itemsId.length) {
      //redirect to subtitute
      let prepareSubstituteData = [];
      for (let i = 0; i < props.orderDetails?.order_items.length; i++) {
        if (
          selectedItemArray.includes(props.orderDetails?.order_items[i]._id)
        ) {
          prepareSubstituteData.push(props.orderDetails?.order_items[i]);
        }
      }
      //alert("time to redirect ");
      dispatch({
        type: SELECTED_SUBSTITUTE_ITEM,
        payload: prepareSubstituteData,
      });
      dispatch({
        type: SUBSTITUTE_EXISTING_RECORDS,
        payload: props.orderDetails,
      });

      history.push("/substituteitem");
    } else {
      setActiveItemData(itemsData[itemCount - 1 + 1]);
      setItemCount(itemCount + 1);
    }
  };

  const onClickChangeStatusAlert = () => {
    Alert.error(
      `<h4>You can't perform this action because payment is not done</h4>`,
      // You can't perform this action because order put on hold
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };

  const onSuccessItems = (data, items, itemsArr) => {
    setItemsData(data);
    setActiveItemData(data[0]);
    setItemsId(items); // this items to update
    setSelectedArray(itemsArr); // this is substitute id
    setItemCount(1); // determine how many we need to show popup show only item
    viewType(6);
  };
  const updateSelectedArray = (itemsArr) => {
    if (itemsArr.length === 0) {
      Alert.error(`<h4>Please select atleast one item to substitute</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      let items = [];
      for (let i = 0; i < props.orderDetails?.order_items.length; i++) {
        if (itemsArr.includes(props.orderDetails?.order_items[i]._id)) {
          if (!items.includes(props.orderDetails?.order_items[i].item.id)) {
            items.push(props.orderDetails?.order_items[i].item.id);
          }
        }
      }

      const token = props.auth.user.accessToken;
      const formData = {
        item_id: items,
      };
      props.get_menu_items_by_passing_item_id_in_array(
        token,
        formData,
        onSuccessItems,
        items,
        itemsArr
      );
      //viewType(6);
    }
  };

  const onSuccessUpdateLocalData = (data) => {
    let updateExistingData = { ...activeItemData };
    updateExistingData.status = data.status;
    setActiveItemData(updateExistingData);
  };

  const changeStatus = (status, id) => {
    const formData = {};
    if (status === undefined) {
      formData.status = false;
    } else {
      formData.status = !status;
    }
    const token = props.auth.user.accessToken;

    props.update_item_menu_setup_without_loader(
      id,
      formData,
      token,
      onSuccessUpdateLocalData
    );
  };

  const [deliveryLink, setDeliveryLink] = useState("");
  const [editLink, showeditLink] = useState(false);

  const updateDeliveryDetails = async () => {
    if (deliveryLink) {
      await amApi.patch(`/ordering/${props.orderDetails?._id}`, {
        home_delivery_details: { link: deliveryLink },
      });
    }
  };

  try {
    return (
      <React.Fragment>
        <SwipeableList className={`swipe`}>
          {({ swipe, ...rest }) => (
            <div className={`${show ? "swipe" : ""}`}>
              <SwipeableListItem
                swipeLeft={{
                  content: (
                    <div>
                      <div className="sectiontwo d-flex swipeOption">
                        {props.type === 20 ? (
                          <>
                            <div className="p-1">
                              <Image
                                alt="wait"
                                title="wait"
                                width="10px"
                                height="13px"
                                src={require("../../../../assets/images/UserManagement/wait.svg")}
                              />
                              <div className="f9-400 opacity5">
                                Total Wait time
                              </div>
                              {/* {props.orderDetails &&
                              props.orderDetails?.order_status === 7 ? ( */}
                              <p className="font_10_m">
                                {seated_time_difference(minutesSeated)}
                              </p>
                              {/* ) : (
                                 <p className="font_10_m">00 HH : 00 min</p>
                               )} */}
                            </div>
                            {/* <div className="sectiontwo-left">
                        <DeletePopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="resonFforCancellation"
                          actionCall={"orderCancelReject"}
                          buttonText="Reject"
                          bigText="Request Reject"
                          mobile={true}
                          reasonText="Are you sure to Reject ?"
                          dataSend={
                            (props.orderDetails &&
                              props.orderDetails?.order_status,
                            props.orderDetails && props.orderDetails?._id)
                          }
                          mobileView
                        />
                      </div>
                      <div className="sectionthree-right">
                        <button
                          className={
                            "n_button_d_status font_18_m popup-save-button"
                          }
                          type={"button"}
                          onClick={() =>
                            onClickChangeStatus(
                              props.orderDetails &&
                                props.orderDetails?.order_status,
                              props.orderDetails && props.orderDetails?._id,
                              props.orderDetails &&
                                props.orderDetails?.order_type
                            )
                          }
                        >
                          Accept
                        </button>
                      </div> */}
                            <div>
                              {props.orderDetails &&
                              props.orderDetails?.order_status === 7 ? (
                                //   ||
                                // (props.orderDetails &&
                                //   props.orderDetails?.order_status === 8)
                                <Fragment></Fragment>
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 8 ? (
                                <button
                                  className="n_button_d_status font_18_m popup-cancel-button"
                                  type="button"
                                  onClick={() =>
                                    onClickResetReject(
                                      props.orderDetails &&
                                        props.orderDetails?.order_status,
                                      props.orderDetails &&
                                        props.orderDetails?._id,
                                      props.orderDetails &&
                                        props.orderDetails?.order_type
                                    )
                                  }
                                >
                                  Reset Order
                                </button>
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 0 ? (
                                <DeletePopup
                                  buttonDisplay="smallCancelButton"
                                  displayPopup="resonFforCancellation"
                                  actionCall={"orderCancelReject"}
                                  buttonText="Reject"
                                  bigText="Request Cancel"
                                  reasonText="Are you sure you want to cancel the order ?"
                                  dataSend={
                                    (props.orderDetails &&
                                      props.orderDetails?.order_status,
                                    props.orderDetails &&
                                      props.orderDetails?._id)
                                  }
                                />
                              ) : (
                                <button
                                  className="n_button_d_status font_18_m popup-cancel-button"
                                  type="button"
                                  onClick={() =>
                                    // props.orderDetails?.onhold
                                    //   ? onClickChangeStatusAlert()
                                    //   :
                                    onClickResetReject(
                                      props.orderDetails &&
                                        props.orderDetails?.order_status,
                                      props.orderDetails &&
                                        props.orderDetails?._id,
                                      props.orderDetails &&
                                        props.orderDetails?.order_type
                                    )
                                  }
                                >
                                  {/* {props.orderDetails &&
                            props.orderDetails?.order_status === 0 ? (
                              "Reject"
                            ) : ( */}
                                  <>
                                    Reset To
                                    <br /> Previous
                                  </>
                                  {/* )} */}
                                </button>
                              )}
                            </div>
                            <div className="middle-timer"></div>
                            <div>
                              {/* // hide button for ccomplete and cancelled */}
                              {(props.orderDetails &&
                                props.orderDetails?.order_status === 7) ||
                              (props.orderDetails &&
                                props.orderDetails?.order_status === 8) ? (
                                <> </>
                              ) : (
                                <button
                                  className="n_button_d_status font_18_m popup-save-button"
                                  type="button"
                                  onClick={() =>
                                    props.orderDetails?.order_status === 4 &&
                                    (props.orderDetails?.payment_status !== 1 ||
                                      getPendingPayment(props.orderDetails))
                                      ? onClickChangeStatusAlert()
                                      : onClickChangeStatus(
                                          props.orderDetails &&
                                            props.orderDetails?.order_status,
                                          props.orderDetails &&
                                            props.orderDetails?._id,
                                          props.orderDetails &&
                                            props.orderDetails?.order_type
                                        )
                                  }
                                >
                                  {props.orderDetails &&
                                  props.orderDetails?.order_status === 1 ? (
                                    "Getting Prep"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 2 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 3 ? (
                                    "Food Plating"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 2 ? (
                                    "Packing"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 1 ? (
                                    <>
                                      Ready for
                                      <br /> Curb Side
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 0 ? (
                                    <>
                                      Ready for
                                      <br /> Take Away
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 2 ? (
                                    <>
                                      Ready for
                                      <br /> Skip the line
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 3 ? (
                                    <>
                                      Ready for
                                      <br /> Dine-in
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 7 ? (
                                    <>
                                      Ready for
                                      <br /> Delivery
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 4 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 3 ? (
                                    "Served"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 4 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 0 ? (
                                    "Delivered"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 4 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 7 ? (
                                    "Out for Delivery"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 4 ? (
                                    "On the way"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 5 ? (
                                    "Delivered"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 6 ? (
                                    "Complete"
                                  ) : null}
                                </button>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="p-1">
                              <Image
                                alt="wait"
                                title="wait"
                                width="10px"
                                height="13px"
                                src={require("../../../../assets/images/UserManagement/wait.svg")}
                              />
                              <div className="f9-400 opacity5">
                                Total Wait time
                              </div>
                              {/* {props.orderDetails &&
                              props.orderDetails?.order_status === 7 ? ( */}
                              <p className="font_10_m">
                                {seated_time_difference(minutesSeated)}
                              </p>
                              {/* ) : (
                                <p className="font_10_m">00 HH : 00 min</p>
                              )} */}
                            </div>
                            {/* <div className="sectiontwo-left">
                        <DeletePopup
                          buttonDisplay="smallCancelButton"
                          displayPopup="resonFforCancellation"
                          actionCall={"orderCancelReject"}
                          buttonText="Reject"
                          bigText="Request Reject"
                          mobile={true}
                          reasonText="Are you sure to Reject ?"
                          dataSend={
                            (props.orderDetails &&
                              props.orderDetails?.order_status,
                            props.orderDetails && props.orderDetails?._id)
                          }
                          mobileView
                        />
                      </div>
                      <div className="sectionthree-right">
                        <button
                          className={
                            "n_button_d_status font_18_m popup-save-button"
                          }
                          type={"button"}
                          onClick={() =>
                            onClickChangeStatus(
                              props.orderDetails &&
                                props.orderDetails?.order_status,
                              props.orderDetails && props.orderDetails?._id,
                              props.orderDetails &&
                                props.orderDetails?.order_type
                            )
                          }
                        >
                          Accept
                        </button>
                      </div> */}
                            <div>
                              {props.orderDetails &&
                              props.orderDetails?.order_status === 7 ? (
                                //   ||
                                // (props.orderDetails &&
                                //   props.orderDetails?.order_status === 8)
                                <Fragment></Fragment>
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 8 ? (
                                <button
                                  className="n_button_d_status font_18_m popup-cancel-button"
                                  type="button"
                                  onClick={() =>
                                    onClickResetReject(
                                      props.orderDetails &&
                                        props.orderDetails?.order_status,
                                      props.orderDetails &&
                                        props.orderDetails?._id,
                                      props.orderDetails &&
                                        props.orderDetails?.order_type
                                    )
                                  }
                                >
                                  Reset Order
                                </button>
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 0 ? (
                                <DeletePopup
                                  buttonDisplay="smallCancelButton"
                                  displayPopup="resonFforCancellation"
                                  actionCall={"orderCancelReject"}
                                  buttonText="Reject"
                                  bigText="Request Cancel"
                                  reasonText="Are you sure want to cancel the order ?"
                                  dataSend={
                                    (props.orderDetails &&
                                      props.orderDetails?.order_status,
                                    props.orderDetails &&
                                      props.orderDetails?._id)
                                  }
                                />
                              ) : (
                                <button
                                  className="n_button_d_status font_18_m popup-cancel-button"
                                  type="button"
                                  onClick={() =>
                                    // props.orderDetails?.onhold
                                    //   ? onClickChangeStatusAlert()
                                    //   :
                                    onClickResetReject(
                                      props.orderDetails &&
                                        props.orderDetails?.order_status,
                                      props.orderDetails &&
                                        props.orderDetails?._id,
                                      props.orderDetails &&
                                        props.orderDetails?.order_type
                                    )
                                  }
                                >
                                  {props.orderDetails &&
                                  props.orderDetails?.order_status === 0 ? (
                                    "Reject"
                                  ) : (
                                    <>
                                      Reset To
                                      <br /> Previous
                                    </>
                                  )}
                                </button>
                              )}
                            </div>
                            <div className="middle-timer"></div>
                            <div>
                              {/* // hide button for ccomplete and cancelled */}
                              {(props.orderDetails &&
                                props.orderDetails?.order_status === 7) ||
                              (props.orderDetails &&
                                props.orderDetails?.order_status === 8) ? (
                                <> </>
                              ) : (
                                <button
                                  className="n_button_d_status font_18_m popup-save-button"
                                  type="button"
                                  onClick={() =>
                                    // props.orderDetails?.onhold
                                    props.orderDetails?.order_status === 4 &&
                                    (props.orderDetails?.payment_status !== 1 ||
                                      getPendingPayment(props.orderDetails))
                                      ? onClickChangeStatusAlert()
                                      : onClickChangeStatus(
                                          props.orderDetails &&
                                            props.orderDetails?.order_status,
                                          props.orderDetails &&
                                            props.orderDetails?._id,
                                          props.orderDetails &&
                                            props.orderDetails?.order_type
                                        )
                                  }
                                >
                                  {props.orderDetails &&
                                  props.orderDetails?.order_status === 0 ? (
                                    "Accept"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 1 ? (
                                    "Getting Prep"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 2 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 3 ? (
                                    "Food Plating"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 2 ? (
                                    "Packing"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 1 ? (
                                    <>
                                      Ready for
                                      <br /> Curb Side
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 0 ? (
                                    <>
                                      Ready for
                                      <br /> Take Away
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 2 ? (
                                    <>
                                      Ready for
                                      <br /> Skip the line
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 3 ? (
                                    <>
                                      Ready for
                                      <br /> Dine-in
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 3 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 7 ? (
                                    <>
                                      Ready for
                                      <br /> Delivery
                                    </>
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 4 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 3 ? (
                                    "Served"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 4 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 0 ? (
                                    "Delivered"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 4 &&
                                    props.orderDetails &&
                                    props.orderDetails?.order_type === 7 ? (
                                    "Out for Delivery"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 4 ? (
                                    "On the way"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 5 ? (
                                    "Delivered"
                                  ) : props.orderDetails &&
                                    props.orderDetails?.order_status === 6 ? (
                                    "Complete"
                                  ) : null}
                                </button>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  ),
                  action: () => setShow(true),
                }}
                swipeRight={{
                  content: <div></div>,
                  action: () => setShow(false),
                }}
                {...rest}
              >
                <Card
                  className={`main-reusable-accordion card-ordering-dashboard-mobile-item `}
                >
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey={props.indexKey + 1}
                    //   className={` ${
                    //     sendDataDinerProps.service_type === "RESERVATION"
                    //       ? "enLeftYellowLine"
                    //       : "enLeftGReenLine"
                    //   }`}
                    className={`${
                      props?.orderDetails?.userConfirmed ? "td_b_g" : "td_b_o"
                    }`}
                  >
                    <div>
                      <div className="row pl-2">
                        <div className="col-2 mpr-1 mobile-p-0">
                          <img
                            src={
                              props?.orderDetails &&
                              props?.orderDetails?.order_type === 0
                                ? require("../../../../assets/images/superadmin/ordericon/takeaway.svg")
                                : props.orderDetails &&
                                  props.orderDetails.order_type === 1
                                ? require("../../../../assets/images/superadmin/ordericon/curb side.svg")
                                : props.orderDetails &&
                                  props.orderDetails.order_type === 3
                                ? require("../../../../assets/images/superadmin/ordericon/dine in.svg")
                                : props.orderDetails &&
                                  props.orderDetails.order_type === 2
                                ? require("../../../../assets/images/superadmin/ordericon/skip the line.svg")
                                : props?.orderDetails?.order_type === 7
                                ? require("../../../../assets/images/superadmin/ordericon/delivery.svg")
                                : ""
                            }
                            alt={
                              ORDER_TYPE_NAME[
                                props?.orderDetails &&
                                  props?.orderDetails?.order_type
                              ]
                            }
                            title={
                              ORDER_TYPE_NAME[
                                props?.orderDetails &&
                                  props?.orderDetails?.order_type
                              ]
                            }
                            width="35px"
                          />
                        </div>
                        <div className="col-3 mpl-1 mpr-1 mobile-p-0">
                          <p className="f10-400">
                            #
                            {props.orderDetails && props.orderDetails?.order_id}
                          </p>
                          <p className="f12-500">
                            {props.orderDetails &&
                            props.orderDetails?.user_details &&
                            props.orderDetails?.user_details.first_name &&
                            props.orderDetails?.user_details.last_name
                              ? props.orderDetails?.user_details.first_name +
                                " " +
                                props.orderDetails?.user_details.last_name
                              : ""}
                          </p>
                        </div>
                        <div className="col-2 mpl-1 mobile-p-0">
                          <div>
                            <p className="f12-500 pl-3">
                              {/* {props.orderDetails &&
                        props.orderDetails?.order_items.length} */}
                              {calcItemsLength(props.orderDetails)}
                            </p>
                          </div>
                        </div>
                        <div className="col-2 mpl-1 mobile-p-0">
                          <div>
                            <span className="f12-500 d-flex align-items-center">
                              <i
                                className="fa fa-inr mr-1"
                                aria-hidden="true"
                              ></i>
                              {!getPendingPayment(props.orderDetails) &&
                              props.orderDetails?.total_amount !== null &&
                              props.orderDetails?.total_amount !== undefined
                                ? props.orderDetails.total_amount?.toFixed(2)
                                : getPendingPayment(
                                    props.orderDetails
                                  )?.toFixed(2)}{" "}
                            </span>
                            <hr className="my-1" />
                            {props?.orderDetails?.payment_status === 1 ||
                            getPendingPayment(props.orderDetails) ? (
                              <div className="d-flex ml-1 align-items-center">
                                <div
                                  className=" f10-500 ml-1"
                                  style={{
                                    color:
                                      props?.orderDetails?.payment_status ===
                                        1 ||
                                      getPendingPayment(props.orderDetails)
                                        ? "#3E9121"
                                        : "#EE3A23",
                                  }}
                                >
                                  {!getPendingPayment(props.orderDetails) &&
                                  props?.orderDetails?.payment_status === 1
                                    ? "PAID"
                                    : getPendingPayment(props.orderDetails) ||
                                      props?.orderDetails?.payment_status === 0
                                    ? "UNPAID"
                                    : props?.orderDetails?.payment_status === 3
                                    ? "FAILURE"
                                    : "N/A"}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                            {props.orderDetails.payment_status !== 1 ||
                            getPendingPayment(props.orderDetails) ? (
                              props.orderDetails?.order_status === 8 ? (
                                ""
                              ) : (
                                <div className="mt-1 mb-1 text-center">
                                  <button
                                    className="btn bg-danger text-white f10-400 px-2 py-1"
                                    onClick={() =>
                                      onClickPayLater(props.orderDetails)
                                    }
                                  >
                                    Pay Now
                                  </button>
                                </div>
                              )
                            ) : (
                              ""
                            )}
                            <span className="f12-400">
                              {props?.orderDetails?.splitPayment ? (
                                <>Split Payment</>
                              ) : (
                                NEW_PAYMENT_TYPE[
                                  props?.orderDetails?.payment_method
                                ]
                              )}
                              {/* {props.orderDetails &&
                              props.orderDetails?.payment_method === 0
                                ? "COD"
                                : props.orderDetails?.payment_method === 1
                                ? "UPI"
                                : props.orderDetails?.payment_method === 2
                                ? "Paytm"
                                : props.orderDetails?.payment_method === 3
                                ? "Debit Card"
                                : props.orderDetails?.payment_method === 4
                                ? "Credit Card"
                                : props.orderDetails?.payment_method === 5
                                ? "NetBanking"
                                : // : props.orderDetails.payment_method === 6
                                // ? "Pay Later"
                                props.orderDetails.payment_method === 7
                                ? "Wallet"
                                : props.orderDetails?.payment_method === 8
                                ? "External Wallet"
                                : props.orderDetails?.payment_method === 9
                                ? "Cash"
                                : null} */}
                            </span>
                          </div>
                        </div>
                        <div className="col-3 mpl-1 ">
                          <span className="f12-500">
                            <div className="f12-500">
                              {props.orderDetails &&
                              props.orderDetails?.order_type === 1 ? (
                                <Fragment>
                                  <div>
                                    {/* {console.log(props.orderDetails)} */}
                                    <p className="f9-500 mb-2">
                                      {props.orderDetails &&
                                        props.orderDetails?.curb_side_details
                                          ?.number}
                                    </p>
                                    <p className="f9-500 opacity5">
                                      {props.orderDetails &&
                                        props.orderDetails?.curb_side_details &&
                                        props.orderDetails?.curb_side_details
                                          .model}
                                      {" | "}
                                      {props.orderDetails &&
                                        props.orderDetails?.curb_side_details &&
                                        props.orderDetails?.curb_side_details
                                          .make}
                                      {" | "}
                                      {props.orderDetails &&
                                        props.orderDetails?.curb_side_details &&
                                        props.orderDetails?.curb_side_details
                                          .vehical_type_value}
                                      {" | "}
                                      {props.orderDetails &&
                                        props.orderDetails?.curb_side_details &&
                                        props.orderDetails?.curb_side_details
                                          .vehical_type}
                                      {" | "}
                                      {props.orderDetails &&
                                        props.orderDetails?.curb_side_details &&
                                        props.orderDetails?.curb_side_details
                                          .year}
                                      {" | "}
                                      {CAR_COLORS &&
                                        CAR_COLORS.map((data, index) => {
                                          return data.value ===
                                            props?.orderDetails
                                              ?.curb_side_details?.color
                                            ? data.name
                                            : "";
                                        })}
                                    </p>
                                    {/* <div
                              className="mt-1"
                              style={{
                                width: "15px",
                                height: "15px",
                                borderRadius: "50%",
                                backgroundColor: `${props.orderDetails &&
                                  props.orderDetails?.curb_side_details &&
                                  props.orderDetails?.curb_side_details.color
                                  }`,
                                boxShadow: "0px 4px 8px #00000029",
                              }}
                            ></div> */}
                                  </div>
                                </Fragment>
                              ) : (props?.orderDetails &&
                                  props?.orderDetails?.order_type === 3) ||
                                (props?.orderDetails &&
                                  props?.orderDetails?.order_type === 2) ? (
                                <Fragment>
                                  {(props?.orderDetails &&
                                    props?.orderDetails?.order_type === 3) ||
                                  (props?.orderDetails &&
                                    props?.orderDetails?.order_type === 2)
                                    ? props?.orderDetails?.dine_in_details
                                        ?.table_number
                                    : "N/A"}
                                </Fragment>
                              ) : props.orderDetails?.order_type === 7 &&
                                props?.orderDetails?.deliveryAddress ? (
                                <React.Fragment>
                                  <a
                                    target="_blank"
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={`https://www.google.com/maps/place/${props.orderDetails?.deliveryAddress?.location?.latitude},${props.orderDetails?.deliveryAddress?.location?.longitude}`}
                                  >
                                    <div className="f10-500 mb-2">
                                      {
                                        props.orderDetails?.deliveryAddress
                                          ?.address1
                                      }
                                    </div>
                                  </a>
                                  <div className="f10-400 mb-2">
                                    {props.orderDetails?.deliveryAddress
                                      ?.area || ""}
                                    ,{" "}
                                    {props.orderDetails?.deliveryAddress
                                      ?.city || ""}
                                  </div>
                                </React.Fragment>
                              ) : (
                                "N/A"
                              )}
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey={props.indexKey + 1}>
                    <Card.Body>
                      {/******* Section One *********/}
                      <hr className="mt-0" />
                      <div className="row">
                        <div
                          className="col-7"
                          style={{ borderRight: "1px solid #E0E0E0" }}
                        >
                          <div className="f12-500 mb-2">
                            Timer/Req. Date/Time
                          </div>
                          <div className="">
                            <div className="date-time-timer-body d-flex">
                              <div className="time-and-edit-button d-flex">
                                <div className="timer-section mr-2">
                                  <div
                                    className="timer-count f14-400"
                                    style={{ color: "#EE3A23" }}
                                  >
                                    {/* {(props.orderDetails &&
                                    props.orderDetails?.order_status === 0) ||
                                  (props.orderDetails &&
                                    props.orderDetails?.order_status === 7) ||
                                  (props.orderDetails &&
                                    props.orderDetails?.order_status === 8) ? (
                                    <> </>
                                  ) : ( */}
                                    {props.orderDetails &&
                                    props.orderDetails?.order_status === 0 ? (
                                      <EventCountDownTimer waitNew={diff} />
                                    ) : (
                                      <NewCountDown waitNew={diff} />
                                    )}
                                    {/* )} */}
                                  </div>
                                </div>
                                {(props.orderDetails &&
                                  props.orderDetails?.order_status === 0) ||
                                (props.orderDetails &&
                                  props.orderDetails?.order_status === 7) ||
                                (props.orderDetails &&
                                  props.orderDetails?.order_status === 8) ? (
                                  <> </>
                                ) : props.orderDetails?.onhold ? (
                                  <PopupIconButtonReusable
                                    buttonClass="editButton"
                                    buttonType="button"
                                    titleText="Edit Timer"
                                    image={require("../../../../assets/images/superadmin/ordericon/Edit.svg")}
                                    onClick={() => onClickChangeStatusAlert()}
                                  />
                                ) : (
                                  <EditWaitTime
                                    actionBy="order"
                                    allDataProps={"123"}
                                    orderId={props.orderDetails?._id}
                                    getUpdatedData={() =>
                                      props.getUpdatedData()
                                    }
                                  />
                                )}
                              </div>
                              <p
                                className="f12-500"
                                style={{ marginLeft: "5px" }}
                              >
                                {calcDate() &&
                                  moment(calcDate()).format("Do MMMM YYYY")}
                                <br />
                                {calcDate() &&
                                  moment(calcDate()).format("hh : mm A")}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div></div>
                        <div
                          className="col-5"
                          // onClick={(e) => {
                          //   viewType(3);
                          //   viewOrderInDetail();
                          // }}
                        >
                          {props.orderDetails?.order_type !== 7 ? (
                            <div className="">
                              <div className="mb-3 f14-500">Locate Users</div>

                              <div>
                                <a>
                                  <img
                                    src={require("../../../../assets/images/ActionImages/pwa-location-img.png")}
                                  ></img>
                                </a>

                                <a
                                  target="_blank"
                                  style={{
                                    fontFamily: "Roboto",
                                  }}
                                  href={`https://www.google.com/maps/place/${props.orderDetails?.track_location?.latitude},${props.orderDetails?.track_location?.longitude}`}
                                >
                                  Location
                                </a>
                              </div>
                            </div>
                          ) : (
                            <div
                              // className="col-4"
                              style={{ borderRight: "1px solid #E0E0E0" }}
                            >
                              <div className="f14-500">
                                Track Delivery Person
                              </div>
                              {props?.orderDetails?.deliveryPerson?.name ||
                              props?.orderDetails?.deliveryPerson?.link ? (
                                <div className="f12-500">
                                  <div>
                                    {props?.orderDetails?.deliveryPerson
                                      ?.name ? (
                                      <p>
                                        Name :{" "}
                                        {props?.orderDetails?.deliveryPerson
                                          ?.name || ""}
                                      </p>
                                    ) : null}
                                    {props?.orderDetails?.deliveryPerson
                                      ?.phoneNumber ? (
                                      <p>
                                        Phone Number :{" "}
                                        {
                                          props?.orderDetails?.deliveryPerson
                                            ?.phoneNumber
                                        }
                                      </p>
                                    ) : null}
                                    {props.orderDetails?.deliveryPerson
                                      ?.link ? (
                                      <a
                                        target="_blank"
                                        style={{
                                          textDecoration: "none",
                                          color: "#2096F3",
                                        }}
                                        href={
                                          props.orderDetails?.deliveryPerson
                                            ?.link
                                        }
                                      >
                                        {
                                          props.orderDetails?.deliveryPerson
                                            ?.link
                                        }
                                      </a>
                                    ) : null}
                                  </div>
                                  {props.orderDetails?.delivery_partner ===
                                  1 ? (
                                    <AssignDeliveryPerson
                                      data={props?.orderDetails}
                                      accessToken={
                                        props.auth?.user?.accessToken
                                      }
                                      getUpdatedData={() =>
                                        props.getUpdatedData()
                                      }
                                      iconButton={true}
                                      selfDeliveryPerson={
                                        props?.orderDetails?.selfDeliveryPerson
                                      }
                                      edit={true}
                                    />
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              ) : props.orderDetails?.delivery_partner === 1 ? (
                                <AssignDeliveryPerson
                                  data={props?.orderDetails}
                                  accessToken={props.auth?.user?.accessToken}
                                  getUpdatedData={() => props.getUpdatedData()}
                                  iconButton={true}
                                  selfDeliveryPerson={
                                    props?.orderDetails?.selfDeliveryPerson
                                  }
                                />
                              ) : (
                                `N/A`
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mt-3 row action-section-body align-items-center">
                        <div className="col-4">
                          {(props.orderDetails &&
                            props.orderDetails?.order_status === 7) ||
                          (props.orderDetails &&
                            props.orderDetails?.order_status === 8) ? (
                            <Fragment></Fragment>
                          ) : props.orderDetails &&
                            props.orderDetails?.order_status === 0 ? (
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="resonFforCancellation"
                              actionCall={"orderCancelReject"}
                              buttonText="Reject"
                              bigText="Request Cancel"
                              reasonText="Are you sure want to cancel the order ?"
                              dataSend={
                                (props.orderDetails &&
                                  props.orderDetails?.order_status,
                                props.orderDetails && props.orderDetails?._id)
                              }
                            />
                          ) : (
                            <button
                              style={{
                                width: "120px !important",
                                minHeight: "48px",
                              }}
                              className="btn btn-danger font_10_m popup-cancel-button"
                              type="button"
                              onClick={() =>
                                onClickResetReject(
                                  props.orderDetails &&
                                    props.orderDetails?.order_status,
                                  props.orderDetails && props.orderDetails?._id,
                                  props.orderDetails &&
                                    props.orderDetails?.order_type
                                )
                              }
                            >
                              {props.orderDetails &&
                              props.orderDetails?.order_status === 0
                                ? "Reject"
                                : "Reset To Previous"}
                            </button>
                          )}
                        </div>
                        <div className="middle-timer col-4 p-0">
                          <p className="font_12_r pl-3">Total Wait time</p>
                          <div
                            className="count-down-timer d-flex py-2 align-items-center"
                            style={{
                              backgroundColor: "#f0f0f0",
                              borderRadius: "6px",
                              minHeight: "40px",
                              width: "120px !important",
                            }}
                          >
                            <i
                              className="fa fa-hourglass-half mr-3"
                              aria-hidden="true"
                            ></i>
                            {/* {props.orderDetails &&
                            props.orderDetails?.order_status === 7 ? ( */}
                            <p className="font_12_m">
                              {seated_time_difference(minutesSeated)}
                            </p>
                            {/* ) : (
                              <p
                                className="font_12_m"
                                style={{
                                  marginTop: "5px",
                                  marginBottom: "5px",
                                }}
                              >
                                00 HH : 00 min
                              </p>
                            )} */}
                          </div>
                          <div className="f12-700 d-flex justify-content-center mt-2">
                            <p className="f12-400">Status:&nbsp;</p>
                            {props.orderDetails &&
                            props.orderDetails?.order_status === 0 ? (
                              "Pending"
                            ) : props.orderDetails?.order_status === 1 ? (
                              "Confirmed"
                            ) : props.orderDetails?.order_status === 2 ? (
                              "Getting Prep"
                            ) : props.orderDetails?.order_status === 3 &&
                              props.orderDetails &&
                              props.orderDetails?.order_type === 3 ? (
                              "Food Plating"
                            ) : props.orderDetails?.order_status === 3 ? (
                              "Packing"
                            ) : props.orderDetails?.order_status === 4 &&
                              props.orderDetails &&
                              props.orderDetails?.order_type === 3 ? (
                              <>
                                Ready for
                                <br /> Dine-in
                              </>
                            ) : props.orderDetails?.order_status === 4 &&
                              props.orderDetails &&
                              props.orderDetails?.order_type === 0 ? (
                              <>
                                Ready for
                                <br /> Take Away
                              </>
                            ) : props.orderDetails?.order_status === 4 &&
                              props.orderDetails &&
                              props.orderDetails?.order_type === 7 ? (
                              <>
                                Ready for
                                <br /> Delivery
                              </>
                            ) : props.orderDetails?.order_status === 4 ? (
                              <>
                                Ready To
                                <br /> Pickup
                              </>
                            ) : props.orderDetails?.order_status === 5 &&
                              props?.orderDetails?.order_type === 7 ? (
                              "Out for Delivery"
                            ) : props.orderDetails?.order_status === 5 ? (
                              "On The Way"
                            ) : props.orderDetails?.order_status === 6 &&
                              props.orderDetails &&
                              props.orderDetails?.order_type === 3 ? (
                              "Served"
                            ) : props.orderDetails?.order_status === 6 ? (
                              "Delivered"
                            ) : props.orderDetails?.order_status === 7 ? (
                              "Complete"
                            ) : props.orderDetails?.order_status === 8 ? (
                              "Cancelled"
                            ) : null}
                            {/* {props.orderDetails &&
                          props.orderDetails?.order_status === 0
                            ? "Pending"
                            : props.orderDetails?.order_status === 1
                            ? "Confirmed"
                            : props.orderDetails?.order_status === 2
                            ? "Getting Prep"
                            : props.orderDetails?.order_status === 3 &&
                              props.orderDetails &&
                              props.orderDetails?.order_type === 3
                            ? "Food Plating"
                            : props.orderDetails?.order_status === 3
                            ? "Packing"
                            : props.orderDetails?.order_status === 4 &&
                              props.orderDetails &&
                              props.orderDetails?.order_type === 3
                            ? "Ready for Dine-in"
                            : props.orderDetails?.order_status === 4
                            ? "Ready To Pick"
                            : props.orderDetails?.order_status === 5
                            ? "On The Way"
                            : props.orderDetails?.order_status === 6 &&
                              props.orderDetails &&
                              props.orderDetails?.order_type === 3
                            ? "Served"
                            : props.orderDetails?.order_status === 6
                            ? "Delivered"
                            : props.orderDetails?.order_status === 7
                            ? "Complete"
                            : props.orderDetails?.order_status === 8
                            ? "Cancelled"
                            : null} */}
                          </div>
                        </div>
                        <div className="col-4">
                          {/* // hide button for ccomplete and cancelled */}
                          {(props.orderDetails &&
                            props.orderDetails?.order_status === 7) ||
                          (props.orderDetails &&
                            props.orderDetails?.order_status === 8) ? (
                            <> </>
                          ) : (props?.orderDetails?.order_status === 3 ||
                              (props?.subscription?.orderSteps === 3 &&
                                props?.orderDetails?.order_status === 2)) &&
                            props?.subscription?.delivery_partner == 1 &&
                            props?.orderDetails?.order_type == 7 ? (
                            <AssignDeliveryPerson
                              data={props?.orderDetails}
                              accessToken={props.auth?.user?.accessToken}
                              getUpdatedData={() => props.getUpdatedData()}
                              mobile={true}
                            />
                          ) : (
                            <button
                              className="btn btn-success font_10_m popup-save-button"
                              type="button"
                              onClick={() =>
                                props.orderDetails?.order_status === 4 &&
                                (props.orderDetails?.payment_status !== 1 ||
                                  getPendingPayment(props.orderDetails))
                                  ? onClickChangeStatusAlert()
                                  : onClickChangeStatus(
                                      props.orderDetails &&
                                        props.orderDetails?.order_status,
                                      props.orderDetails &&
                                        props.orderDetails?._id,
                                      props.orderDetails &&
                                        props.orderDetails?.order_type
                                    )
                              }
                              style={{
                                width: "100px",
                                minHeight: "48px",
                              }}
                            >
                              {props.orderDetails &&
                              props.orderDetails?.order_status === 0 ? (
                                "Accept"
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 1 ? (
                                "Getting Prep"
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 2 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 3 ? (
                                "Food Plating"
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 2 ? (
                                "Packing"
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 3 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 1 ? (
                                <>
                                  Ready for
                                  <br /> Curb Side
                                </>
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 3 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 0 ? (
                                <>
                                  Ready for
                                  <br /> Take Away
                                </>
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 3 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 7 ? (
                                <>
                                  Ready for
                                  <br /> Delivery
                                </>
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 3 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 2 ? (
                                <>
                                  Ready for
                                  <br /> Skip the line
                                </>
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 3 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 3 ? (
                                <>
                                  Ready for
                                  <br /> Dine-in
                                </>
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 4 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 3 ? (
                                "Served"
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 4 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 0 ? (
                                "Delivered"
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 4 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 7 ? (
                                "Out for Delivery"
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 4 ? (
                                "On the way"
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 5 ? (
                                "Delivered"
                              ) : props.orderDetails &&
                                props.orderDetails?.order_status === 6 ? (
                                "Complete"
                              ) : null}
                              {/* {props.orderDetails &&
                            props.orderDetails?.order_status === 0
                              ? "Accept"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 1
                              ? "Getting Prep"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 2 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 3
                              ? "Food Plating"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 2
                              ? "Packing"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 3 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 1
                              ? "Ready for Curb Side"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 3 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 0
                              ? "Ready for Take Away"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 3 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 2
                              ? "Ready for Skip the line"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 3 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 3
                              ? "Ready for Dine-in"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 4 &&
                                props.orderDetails &&
                                props.orderDetails?.order_type === 3
                              ? "Served"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 4
                              ? "On the way"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 5
                              ? "Delivered"
                              : props.orderDetails &&
                                props.orderDetails?.order_status === 6
                              ? "Complete"
                              : null} */}
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12">
                          <div className="more-actions-orders-desc d-flex align-items-center justify-content-center mb-2">
                            {/* <SuperAdminCall /> */}
                            <CallingButtonPopup
                              sendData={props.orderDetails}
                              displayButton={"OrderMain"}
                            />{" "}
                            {/* <CallingCardDraggable
                              sendData={sendDataFunction(
                                props?.orderDetails?.user_details
                              )}
                              displayButton={"OrderMain"}
                            /> */}
                            <ViewMobileOrder
                              allData={props.orderDetails}
                              openViewWhenScan={openViewWhenScan}
                              resetopenViewWhenScan={() =>
                                setopenViewWhenScan(false)
                              }
                              orderDetails={
                                props?.orderDetails && props?.orderDetails
                              }
                            />
                            <SendSmsNew
                              mobile_number={
                                props.orderDetails &&
                                props.orderDetails?.user_details &&
                                props.orderDetails?.user_details.mobile_number
                              }
                              first_name={
                                props.orderDetails &&
                                props.orderDetails?.user_details &&
                                props.orderDetails?.user_details.first_name
                              }
                              type="order"
                              order_id={props.orderDetails?._id}
                            />
                            {/* <Button
                            variant="link"
                            className="enIconBtn mr-3 action_icon_padding"
                            onClick={() => {
                              viewType(1);
                              viewOrderInDetail();
                            }}
                          >
                            <Image
                              src={require("../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>{" "} */}
                            {/* <SendSmsNew
                            mobile_number={
                              props.orderDetails &&
                              props.orderDetails?.user_details &&
                              props.orderDetails?.user_details.mobile_number
                            }
                            first_name={
                              props.orderDetails &&
                              props.orderDetails?.user_details &&
                              props.orderDetails?.user_details.first_name
                            }
                            type="order"
                            order_id={props.orderDetails?._id}
                          /> */}
                            {/* <Button
                            variant="link"
                            className="enIconBtn mr-3 action_icon_padding"
                            onClick={() => {
                              viewType(2);
                              viewOrderInDetail();
                            }}
                          >
                            <Image
                              src={require("../../../../assets/images/superadmin/ordericon/Edit.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>{" "} */}
                            {props?.orderDetails?.order_status === 8 ||
                            props?.orderDetails?.order_status === 7 ? (
                              ""
                            ) : (
                              // <Button
                              //   variant="link"
                              //   className="enIconBtn mr-3"
                              //   onClick={() =>
                              //     onClickEditOrder(props?.orderDetails)
                              //   }
                              // >
                              //   <Image
                              //     src={require("../../../../assets/images/UserManagement/pencil.svg")}
                              //     alt="Edit"
                              //     title="Edit"
                              //     fluid
                              //     style={{ margin: "8px" }}
                              //   />
                              // </Button>
                              <EditOrder
                                orderDetails={
                                  props?.orderDetails && props?.orderDetails
                                }
                                seated_time_difference={seated_time_difference(
                                  minutesSeated
                                )}
                              />
                            )}
                            <NotificationsNew
                              order_id={props.orderDetails?._id}
                              dataSend={props?.orderDetails}
                            />
                            <ChatWindow
                              data={props.orderDetails}
                              text={"order"}
                            />
                          </div>
                        </div>
                        {/*<div className="col-4">
                         {(props.orderDetails &&
                          props.orderDetails?.order_status === 7) ||
                        (props.orderDetails &&
                          props.orderDetails?.order_status === 8) ||
                        (props.orderDetails &&
                          props.orderDetails?.order_status === 0) ? (
                          <Fragment></Fragment>
                        ) : (
                          <div align="center" style={{ paddingLeft: "5px" }}>
                            <div
                              onClick={() =>
                                onChangeHold(
                                  props.orderDetails &&
                                    props.orderDetails?.onhold,
                                  props.orderDetails && props.orderDetails?._id
                                )
                              }
                              style={{
                                borderRadius: "50%",
                                width: "25px",
                                border: "1px solid #FCB62B",
                                padding: "5px",
                              }}
                            >
                              <i
                                style={{ color: "#FCB62B", width: "100%" }}
                                className="fa fa-pause"
                                className={`${
                                  props.orderDetails &&
                                  props.orderDetails?.onhold
                                    ? "fa fa-play"
                                    : "fa fa-pause"
                                }`}
                              ></i>
                            </div>
                            <div className="f10-500">
                              {props.orderDetails &&
                              props.orderDetails?.order_type !== 8 ? (
                                <>
                                  {props.orderDetails &&
                                  props.orderDetails?.onhold
                                    ? "Resume"
                                    : "Put on hold"}
                                </>
                              ) : (
                                <> </>
                              )}
                            </div>
                          </div>
                        )} 
                      </div>*/}
                      </div>
                      <div className="row mt-3">
                        <div
                          className={
                            props?.orderDetails?.order_type === 1
                              ? "col-3"
                              : "col-4"
                          }
                        >
                          <div className="f12-500 mb-2"> More Action</div>
                          {(props.orderDetails &&
                            props.orderDetails?.order_status === 7) ||
                          (props.orderDetails &&
                            props.orderDetails?.order_status === 6) ||
                          (props.orderDetails &&
                            props.orderDetails?.order_status === 8) ? (
                            <> </>
                          ) : (
                            //
                            <button
                              style={{ fontWeight: "700", fontSize: "1.2vh" }}
                              className="btn order-outlinecancel-button"
                              onClick={() =>
                                onClickCancelOrder(
                                  props.orderDetails && props.orderDetails?._id
                                )
                              }
                            >
                              Cancel Order
                            </button>
                          )}
                        </div>
                        <div
                          className={
                            props?.orderDetails?.order_type === 1
                              ? "col-3"
                              : "col-4"
                          }
                        >
                          <div className="f12-500 mb-2">Order Notes</div>
                          {props.orderDetails && props.orderDetails?.notes}
                        </div>
                        <div
                          className={
                            props?.orderDetails?.order_type === 1
                              ? "col-3"
                              : "col-4"
                          }
                        >
                          <div className="f12-500 mb-2">ETR</div>
                          <p>
                            {props.orderDetails?.reaching_time
                              ? `${props.orderDetails?.reaching_time}min`
                              : "N/A"}
                          </p>
                        </div>
                        {props?.orderDetails?.order_type === 1 && (
                          <div className="col-3">
                            <div className="f12-500 mb-2">Track</div>
                            <button
                              className="btn btn-success"
                              onClick={() => onEnableTrack(props.orderDetails)}
                              disabled={props.orderDetails?.order_status !== 4}
                            >
                              Enable
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="row seating-dashboard-table">
                        <div className="col-4 mpl-1 ">
                          <p className="f12-700">Order Items</p>
                        </div>
                        <div className="col-4 mpl-1 mobile-p-0">
                          <p className="f12-700">Qty/Size</p>
                        </div>
                        <div className="col-4 mpl-1 ">
                          <p className="f12-700">Item Status</p>
                        </div>
                      </div>

                      {props.orderDetails &&
                        props.orderDetails?.order_items.map((item, index) => (
                          <Fragment key={index}>
                            {!item.isSubstituted ? (
                              <>
                                <div className="row">
                                  <div className="col-12 d-flex">
                                    <div className="col-4 d-flex p-0 align-items-center">
                                      <Image
                                        src={
                                          (item.item.images &&
                                            item.item.images[0]) ||
                                          NOTAVAILABLEIMAGE
                                        }
                                        alt="Item Image"
                                        title={item.item.name}
                                        fluid
                                        style={{
                                          borderRadius: "3px",
                                          width: "35px",
                                          height: "35px",
                                        }}
                                        className="mr-2"
                                      />
                                      {ITEMTYPEVEG.map((type, index) => {
                                        return (
                                          <React.Fragment key={index}>
                                            {item?.item?.itemType ===
                                            type?.value ? (
                                              <Image
                                                width="12px"
                                                height="12px"
                                                src={type.url}
                                                alt={type.title}
                                                title={type.title}
                                                fluid
                                              />
                                            ) : null}
                                          </React.Fragment>
                                        );
                                      })}
                                      &nbsp;&nbsp;
                                      <div className="f12-400">
                                        {item.item.name}
                                      </div>
                                    </div>
                                    <div className="col-4">
                                      <div>{item.quantity}</div>
                                      <div>
                                        {item?.size?.uom !== undefined &&
                                        item?.size?.uom !== null &&
                                        item?.size?.uom !== "" ? (
                                          <div className="f9-400 d-flex">
                                            UOM - {item?.size?.uom}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-4">
                                      <div className="btn mb-2 f12-400 btn-outline-success text-success">
                                        {props?.orderDetails &&
                                        props?.orderDetails?.order_status ===
                                          0 ? (
                                          "Pending"
                                        ) : props?.orderDetails
                                            ?.order_status === 1 ? (
                                          "Confirmed"
                                        ) : props?.orderDetails
                                            ?.order_status === 2 ? (
                                          "Getting Prep"
                                        ) : props?.orderDetails
                                            ?.order_status === 3 &&
                                          props?.orderDetails &&
                                          props?.orderDetails?.order_type ===
                                            3 ? (
                                          "Food Plating"
                                        ) : props?.orderDetails
                                            ?.order_status === 3 ? (
                                          "Packing"
                                        ) : props?.orderDetails
                                            ?.order_status === 4 &&
                                          props?.orderDetails &&
                                          props?.orderDetails?.order_type ===
                                            3 ? (
                                          <>
                                            Ready for
                                            <br /> Dine-in
                                          </>
                                        ) : props?.orderDetails
                                            ?.order_status === 4 &&
                                          props?.orderDetails &&
                                          props?.orderDetails?.order_type ===
                                            7 ? (
                                          <>
                                            Ready for
                                            <br /> Delivery
                                          </>
                                        ) : props?.orderDetails
                                            ?.order_status === 4 ? (
                                          <>
                                            Ready To
                                            <br /> Pick
                                          </>
                                        ) : props?.orderDetails
                                            ?.order_status === 5 &&
                                          props?.orderDetails?.order_type ===
                                            7 ? (
                                          <>
                                            Out for
                                            <br /> Delivery
                                          </>
                                        ) : props?.orderDetails
                                            ?.order_status === 5 ? (
                                          "On The Way"
                                        ) : props?.orderDetails
                                            ?.order_status === 6 &&
                                          props?.orderDetails &&
                                          props?.orderDetails?.order_type ===
                                            3 ? (
                                          "Served"
                                        ) : props?.orderDetails
                                            ?.order_status === 6 ? (
                                          "Delivered"
                                        ) : props?.orderDetails
                                            ?.order_status === 7 ? (
                                          "Complete"
                                        ) : props?.orderDetails
                                            ?.order_status === 8 ? (
                                          "Cancelled"
                                        ) : null}
                                      </div>
                                      {/* <Button
                                        variant="outline-success"
                                        style={{ fontSize: "12px" }}
                                      >
                                        Packing
                                      </Button> */}
                                      <div className="f10-400">
                                        Current Status
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <hr />
                                <div className="row">
                                  <div className="col-4">
                                    <div className="f10-400">
                                      <b>Customization</b>
                                    </div>
                                    <div className="f9-400">
                                      {item && item.addOns.length > 0 ? (
                                        getAddOns(item && item.addOns).map(
                                          (data, index) => {
                                            console.log(data);
                                            return (
                                              <div className="row" key={index}>
                                                <div className="col-7 px-2 py-2 f10-400">
                                                  {data?.name}
                                                </div>
                                                <div className="col-5 text-right py-2 f10-400">
                                                  {data?.price !== undefined &&
                                                  data.price !== null &&
                                                  data.price !== ""
                                                    ? ` ₹${data.price}`
                                                    : ""}
                                                </div>
                                                {console.log()}
                                                <div className="col-12 f10-500">
                                                  {data?.multipleSize
                                                    ?.length ? (
                                                    data?.multipleSize?.map(
                                                      (sizes, index) => {
                                                        return sizes?.checked ===
                                                          true ? (
                                                          <React.Fragment
                                                            key={index}
                                                          >
                                                            <div className="row align-items-center">
                                                              <div className="col-7">
                                                                {
                                                                  sizes?.sizeDescription
                                                                }
                                                              </div>
                                                              <div className="col-5 text-right">
                                                                ₹{" "}
                                                                {
                                                                  sizes?.itemPrice
                                                                }
                                                              </div>
                                                            </div>
                                                          </React.Fragment>
                                                        ) : null;
                                                      }
                                                    )
                                                  ) : typeof data?.multipleSize ==
                                                    "object" ? (
                                                    <div className="row align-items-center">
                                                      <div className="col-7">
                                                        {
                                                          data?.multipleSize
                                                            ?.sizeDescription
                                                        }
                                                      </div>
                                                      <div className="col-5 text-right">
                                                        ₹{" "}
                                                        {
                                                          data?.multipleSize
                                                            ?.itemPrice
                                                        }
                                                      </div>
                                                    </div>
                                                  ) : null}
                                                </div>
                                                <div className="col-12 pl-1 pr-3">
                                                  <hr className="m-1" />
                                                </div>
                                              </div>
                                            );
                                          }
                                        )
                                      ) : (
                                        <Fragment>N/A</Fragment>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="f10-400">
                                      <b>
                                        Personalization/
                                        <br />
                                        Item Notes
                                      </b>
                                    </div>
                                    <div className="f9-400">
                                      {item && item.customised_details
                                        ? prepareLevels(
                                            item && item.customised_details
                                          )
                                        : " "}{" "}
                                      {item && item.notes}
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="f10-400">
                                      <b>Size Options</b>
                                    </div>
                                    <div className="f9-400">
                                      {item && item.customised_details
                                        ? prepareLevels(
                                            item && item.customised_details
                                          )
                                        : " "}{" "}
                                      {item && item.notes}
                                    </div>
                                  </div>
                                </div>
                                <hr />
                                <div
                                  className="row pb-3 border-bottom mb-2 "
                                  style={{
                                    boxShadow: "0 5.8px 4.2px rgb(0 0 0 / 3%)",
                                  }}
                                >
                                  <div className="col-3">
                                    <div className="f10-400">
                                      <b>Amount</b>
                                    </div>
                                    <div className="f9-400">
                                      <br />
                                      <br />₹{" "}
                                      {item && item.size && item.size.price}
                                    </div>
                                  </div>
                                  <div className="col-3">
                                    <div className="f10-400">
                                      <b>ETC</b>
                                    </div>
                                    <br />
                                    <div className="f9-400">
                                      {item && item.item && item.item.prepTime}{" "}
                                    </div>
                                  </div>
                                  <div className="col-3">
                                    <div className="f10-400">
                                      <b>Counter No.</b>
                                    </div>
                                    <br />
                                    <div className="f9-400">
                                      {item &&
                                        item.item &&
                                        item.item.counter_number}
                                    </div>
                                  </div>
                                  <div className="col-3">
                                    <div className="f10-400">
                                      <b>
                                        Substituted/
                                        <br /> Cancelled
                                      </b>
                                    </div>
                                    <div className="f9-400">
                                      {item.isCancelled ||
                                      props.orderDetails?.order_status === 8 ? (
                                        "Cancelled"
                                      ) : props.orderDetails?.order_status ===
                                        7 ? (
                                        "Completed"
                                      ) : (
                                        <Fragment>
                                          <div align="center">
                                            <div className="col-12">
                                              <img
                                                src={require("../../../../assets/images/superadmin/ordericon/uncheck.svg")}
                                                width="25px"
                                                alt="Substitute"
                                                className="mb-2"
                                              />
                                            </div>
                                            <button
                                              className="px-2 f10-500 text-white btn"
                                              style={{
                                                backgroundColor: "#EE3A23",
                                                border: "1px solid #FD0D1B",
                                                borderRadius: "6px",
                                                width: "100%",
                                              }}
                                              disabled={[
                                                2, 3, 4, 5, 6,
                                              ].includes(
                                                props?.orderDetails
                                                  ?.order_status
                                              )}
                                              onClick={() =>
                                                onClickShowSubstituteModal(
                                                  item,
                                                  props.orderDetails?._id,
                                                  index
                                                )
                                              }
                                            >
                                              Substitute/
                                              <br />
                                              Cancel
                                            </button>
                                          </div>
                                        </Fragment>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              <></>
                            )}
                          </Fragment>
                        ))}
                      <hr />
                      <div className="f12-700 mb-2">Order Summary</div>
                      <div className="row">
                        <div className="col-6 f14-500  py-1">Sub Total</div>
                        <div className="col-6 f14-500 py-1 text-right pl-1">
                          {/* {props.orderDetails?.total_amount !== null &&
                          props.orderDetails?.total_amount !== undefined
                            ? props.orderDetails.total_amount?.toFixed(2)
                            : ""} */}
                          {props.orderDetails?.base_amount !== null &&
                          props.orderDetails?.base_amount !== undefined
                            ? props.orderDetails.base_amount?.toFixed(2)
                            : ""}
                        </div>
                        <div className="col-6 f12-700 opacity5 py-1">Taxes</div>
                        <div className="col-6 f12-700 py-1 text-right pl-1">
                          {props &&
                          props.orderDetails &&
                          props.orderDetails?.gstAmount ? (
                            <>{calcTaxes(props.orderDetails?.gstAmount)}</>
                          ) : (
                            <>- </>
                          )}
                        </div>
                        <div className="col-6 f12-700 opacity5 py-1">
                          Surcharges
                        </div>
                        <div className="col-6 f12-700 py-1 text-right pl-1">
                          {props &&
                          props.orderDetails &&
                          props.orderDetails?.surCharges ? (
                            <>₹{calcTaxes(props.orderDetails?.surCharges)}</>
                          ) : (
                            <>- </>
                          )}
                        </div>
                        <div className="col-6 f12-700 opacity5 py-1">
                          Donation
                        </div>
                        <div className="col-6 f12-700 py-1 text-right pl-1">
                          ₹
                          {props &&
                          props.orderDetails &&
                          props.orderDetails?.donation &&
                          props.orderDetails?.donation.amount
                            ? props.orderDetails?.donation.amount?.toFixed(2)
                            : 0}
                        </div>
                        <div className="col-6 f12-700 opacity5 py-1">
                          Discount
                        </div>
                        <div className="col-6 f12-700 py-1 text-right pl-1">
                          ₹
                          {props &&
                          props.orderDetails &&
                          props.orderDetails?.discount &&
                          props.orderDetails?.discount.amount
                            ? props.orderDetails?.discount.amount?.toFixed(2)
                            : 0}
                        </div>
                        <div className="col-6 f12-700 opacity5 py-1">Tip</div>
                        <div className="col-6 f12-700 py-1 text-right pl-1">
                          ₹
                          {props &&
                          props.orderDetails &&
                          props.orderDetails?.tip &&
                          props.orderDetails?.tip.amount
                            ? props.orderDetails?.tip.amount?.toFixed(2)
                            : 0}
                        </div>
                      </div>
                      <br />
                      <div
                        className="row"
                        style={{
                          background: "#F8F8F8 0% 0% no-repeat padding-box",
                        }}
                      >
                        <div className="col-6 f14-500 ">
                          Amount{" "}
                          {props &&
                          props.orderDetails &&
                          props.orderDetails?.payment_status === 1
                            ? "Paid"
                            : props &&
                              props.orderDetails &&
                              props.orderDetails?.payment_status === 0
                            ? "Unpaid"
                            : props.orderDetails?.payment_status === 3
                            ? "Failure"
                            : "N/A"}
                        </div>
                        <div className="col-6 f14-500 py-1 pl-1 text-right">
                          &nbsp;&nbsp;&nbsp;₹{" "}
                          {props.orderDetails?.total_amount !== null &&
                          props.orderDetails?.total_amount !== undefined
                            ? props.orderDetails?.total_amount?.toFixed(2)
                            : ""}
                        </div>
                        {/* <div className="f14-500 hh">
                       
                       
                      </div> */}
                      </div>
                      <div>
                        <Modal
                          show={MrDetail.MrDetail}
                          onHide={() => {
                            viewOrderInDetail();
                          }}
                          centered
                          size={vtype === 3 ? "md" : "xl"}
                        >
                          <Modal.Header className="border-0 pl-4" closeButton>
                            <Modal.Title className="f24-700">
                              {vtype === 1 && "View Order Details"}
                              {vtype === 2 && "Edit Order Details"}
                              {vtype === 3 && "User Location"}
                              {vtype === 4 && "Substitute Item"}
                              {vtype === 5 && "Select Items To Substitute"}
                              {vtype === 6 && "Update Availability of Item"}
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body className="p-4 f16-500">
                            <div className="">
                              {vtype === 1 && (
                                <ViewMobileOrder
                                  onClickShowSubstituteModal={(
                                    data1,
                                    data2,
                                    data3
                                  ) =>
                                    onClickShowSubstituteModal(
                                      data1,
                                      data2,
                                      data3
                                    )
                                  }
                                  onClickCancelOrder={(id) =>
                                    onClickCancelOrder(id)
                                  }
                                  seated_time_difference={() =>
                                    seated_time_difference(minutesSeated)
                                  }
                                  onUpdateOrderStatus={(data) =>
                                    props.onUpdateOrderStatus(data)
                                  }
                                  orderDetails={
                                    props.orderDetails && props.orderDetails
                                  }
                                />
                              )}
                              {vtype === 2 && (
                                <OrderEditModelBody
                                  orderDetails={
                                    props?.orderDetails && props?.orderDetails
                                  }
                                  seated_time_difference={seated_time_difference(
                                    minutesSeated
                                  )}
                                />
                              )}
                              {vtype === 3 && <OrderLocation />}
                              {vtype === 4 && (
                                <SubstituteModal
                                  itemData={substituteItemData}
                                  allData={props.orderDetails}
                                />
                              )}
                              {vtype === 5 && (
                                <SelectItemsToSubs
                                  //selectItems={selectItems}
                                  allData={props.orderDetails}
                                  updateSelectedArray={(itemArr) =>
                                    updateSelectedArray(itemArr)
                                  }
                                />
                              )}
                              {vtype === 6 && (
                                <UpdateAvailabilityOfItem
                                  item={activeItemData}
                                  changeStatus={(status, itemId) =>
                                    changeStatus(status, itemId)
                                  }
                                  onClickNext={() => onClickNext()}
                                />
                              )}
                            </div>
                            {/* <EditUser
                            data={currentUserData}
                            CloseEdit={handleCloseEdit}
                          /> */}
                          </Modal.Body>
                        </Modal>
                      </div>
                      <React.Fragment>
                        <Modal
                          show={showSubstitute}
                          onHide={handleCloseSubstitute}
                          centered
                        >
                          <Modal.Header
                            className="py-0 pt-2 border-0"
                            closeButton
                          >
                            <Modal.Title>Substitute/Cancel</Modal.Title>
                          </Modal.Header>
                          <Modal.Body className="f16-500">
                            Select one relevant option from Below
                            <div className="row mt-3">
                              {["Substitute", "Cancel Item"].map(
                                (data, index) => {
                                  return (
                                    <div className="col-6 col-md-3" key={index}>
                                      <PopupInsideButton
                                        buttonClass={
                                          data === subType
                                            ? "status-selected-button-box f14-500 sts_sld_btn_box_a"
                                            : "status-selected-button-box f14-500"
                                        }
                                        buttonText={data}
                                        buttonType="button"
                                        onClick={() => setSubType(data)}
                                      />
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </Modal.Body>
                          <Modal.Footer className="justify-content-start border-0">
                            <Button
                              variant="outline-secondary"
                              className="btn-lg mr-4 px-5"
                              onClick={() => handleCloseSubstitute()}
                              //onClick={handleCloseFlag}
                            >
                              Back
                            </Button>
                            <Button
                              variant="danger"
                              className="btn-lg px-5"
                              onClick={() => handleClickConfirm()}
                              //onClick={() => handleFlagUser(props.user._id, props.user.isFlag)}
                            >
                              Confirm
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        <Modal
                          show={showHoldOrder}
                          onHide={handleCloseHoldOrder}
                          centered
                        >
                          <Modal.Header
                            className="py-0 pt-2 border-0"
                            closeButton
                          >
                            <Modal.Title></Modal.Title>
                          </Modal.Header>
                          <Modal.Body className="f16-500">
                            Are you sure to put this order on hold ?
                          </Modal.Body>
                          <Modal.Footer className="justify-content-start border-0">
                            <Button
                              variant="outline-secondary"
                              className="btn-lg mr-4 px-5"
                              onClick={handleCloseHoldOrder}
                            >
                              No
                            </Button>
                            <Button
                              variant="danger"
                              className="btn-lg px-5"
                              // onClick={handleCloseBlockUser}
                              onClick={() => onClickHoldOrder()}
                            >
                              Yes
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </React.Fragment>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </SwipeableListItem>
            </div>
          )}
        </SwipeableList>
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
}

// export default VendorOrderTablesBodyMobile;

VendorOrderTablesBodyMobile.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  servicesEnabled:
    state.onboarding.onboard_subscription_details.casual_dining_status &&
    state.onboarding.onboard_subscription_details.casual_dining_status.ordering,
  allOrderDataa: state.vendorOrdering.vendor_get_all_takeaway_order,
  onboarding: state.onboarding.restaurantDetails,
  subscription: state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  cancel_item_order,
  debit_memo_order_cancel_item,
  edit_location,
  get_menu_items_by_passing_item_id_in_array,
  update_item_menu_setup_without_loader,
})(VendorOrderTablesBodyMobile);
